export const useButton = ({
    disabled,
    Element = 'button',
}: Record<string, unknown>): {
    ariaProps: { [x: string]: unknown };
} => {
    let additionalAttributes: { [x: string]: unknown } = {};

    if (Element === 'button') {
        additionalAttributes = {};
    } else {
        additionalAttributes = {
            role: 'button',
            tabIndex: disabled ? undefined : 0,
            'aria-disabled': disabled,
        };
    }

    return {
        ariaProps: additionalAttributes,
    };
};
